// extracted by mini-css-extract-plugin
module.exports = {"VideoVodPlayer":"styles_VideoVodPlayer__mfPC_","VerticalVideoContainer":"styles_VerticalVideoContainer__seEbH"};